export default {
  root: {
    class: [
      // Flex & Alignment
      'flex items-center justify-between flex-wrap',
      'gap-2',

      // Spacing
      'p-5',

      // Shape
      'rounded-md',

      // Color
      'bg-secondary-50 dark:bg-secondary-800',
      'border border-secondary-200 dark:border-secondary-700'
    ]
  },
  start: {
    class: 'flex items-center'
  },
  center: {
    class: 'flex items-center'
  },
  end: {
    class: 'flex items-center'
  }
};
